/* eslint-disable max-len */
import 'slick-carousel';

const $activitiesCarousel = $('.js-activities-carousel');
const $activitiesCounter = $('.js-activities-carousel__counter');
const $activitiesCounterTotal = $('.js-activities-carousel__counter-total');

const $activitiesProductCarousel = $('.js-activities-product-carousel');

$('.js-background-images').slick({
  dots: false,
  arrows: false,
  autoplay: true,
  autoplaySpeed: 2500,
  fade: true,
  cssEase: 'linear',
  speed: 1000,
});

$('.js-promo-pops-carousel').slick({
  dots: false,
  infinite: true,
  speed: 300,
  slidesToShow: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  // eslint-disable-next-line
  prevArrow: '<div class="slick-prev-arrow fa fa-chevron-circle-left"></div>',
  // eslint-disable-next-line
  nextArrow: '<div class="slick-next-arrow fa fa-chevron-circle-right"></div>',
});

$('.js-blog-carousel').slick({
  dots: false,
  infinite: true,
  speed: 1000,
  slidesToShow: 1,
  autoplay: true,
  autoplaySpeed: 3000,
  prevArrow:
    '<div class="slick-prev-arrow"><img src="/SiteFiles/src/ui/img/blogger/arrow_left.svg" alt="Previous"></div>',
  nextArrow:
    '<div class="slick-next-arrow"><img src="/SiteFiles/src/ui/img/blogger/arrow_right.svg" alt="Next"></div>',
});

$('.js-blog-article-carousel').slick({
  dots: false,
  infinite: true,
  speed: 1000,
  slidesToShow: Math.min(3, $('.blogger-listing-area__item').length),
  autoplay: true,
  autoplaySpeed: 3000,
  prevArrow:
    '<div class="slick-prev-arrow"><img src="/SiteFiles/src/ui/img/blogger/arrow_left.svg" alt="Previous"></div>',
  nextArrow:
    '<div class="slick-next-arrow"><img src="/SiteFiles/src/ui/img/blogger/arrow_right.svg" alt="Next"></div>',
  responsive: [
    {
      breakpoint: 992,
      settings: {
        slidesToShow: Math.min(2, $('.blogger-listing-area__item').length),
      },
    },
    {
      breakpoint: 768,
      settings: {
        slidesToShow: 1,
      },
    },
  ],
});

$activitiesCarousel.on('init reInit afterChange', (event, slick, currentSlide) => {
  const i = (currentSlide || 0) + 1;
  $activitiesCounter.text(`${i}`);
  $activitiesCounterTotal.text(`${slick.slideCount}`);
});

$('.js-btn-next').click(() => {
  $activitiesCarousel.slick('slickNext');
});

$('.js-btn-prev').click(() => {
  $activitiesCarousel.slick('slickPrev');
});

$activitiesCarousel.slick({
  dots: false,
  infinite: false,
  speed: 1000,
  centerMode: false,
  autoplay: false,
  variableWidth: true,
  swipeToSlide: true,
  arrows: false,
});

$activitiesProductCarousel.slick({
  dots: false,
  infinite: true,
  speed: 1000,
  centerMode: false,
  autoplay: false,
  variableWidth: true,
  swipeToSlide: true,
  arrows: false,
});

$('.js-product-next').click(() => {
  $activitiesProductCarousel.slick('slickNext');
});

$('.js-product-prev').click(() => {
  $activitiesProductCarousel.slick('slickPrev');
});

$('.js-activities-carousel-number').click(e => {
  const targetIndex = e.currentTarget.getAttribute('data-index');
  $activitiesProductCarousel.slick('slickGoTo', targetIndex);
});

$activitiesProductCarousel.on('afterChange', (e, slick) => {
  $('.js-activities-carousel-number').removeClass('active');
  $(`.js-activities-carousel-number[data-index='${slick.currentSlide}']`).addClass('active');
});
